import example from './example'
import example2 from './example2'
import createAdmin from './createAdmin'
import editBatchNo from './editBatchNo'
import previewTraceQr from './previewTraceQr'
import dealOrder from './dealOrder'
import batchList from "./batchList";
import registerUserProto from "./registerUserProto";
import adminPay from './adminPay'
import orderDetail from './orderDetail'

export default {
  example,
  example2,
  createAdmin,
  editBatchNo,
  previewTraceQr,
  dealOrder,
  batchList,
  registerUserProto,
  adminPay,
  orderDetail,
}